<template>
    <div class="row operation-card">
    <div class="col" v-if="!isInEdit && operation && algorithms">
        <div class="row">
            <div class="col">
                <div class="d-flex operation-card-actions align-items-center justify-content-between">
                    <router-link class="btn btn-back btn-lg" :to="`/settings/print-machine-operations/${pmId}`" tag="button">
                        <i class="ico ico-close"></i>
                    </router-link>
                    <h2 class="ml-4">{{operation.name}}</h2>
                    <div class="d-flex">
                        <button type="button" class="ml-4 btn btn-outline-secondary" @click="deleteOperation"><i class="ico ico-delete"></i></button>
                        <button type="button" class="ml-2 btn btn-outline-secondary"  @click="editOperation"><i class="ico ico-pencil"></i></button>
                    </div>
                </div>
            </div>
        </div>
         <div class="row mt-4">
             <div class="col print-machine-properties">
                <div>
                    <span class="print-machine-property-name">Статус:</span>
                    <div class="print-machine-property-pill" :class="{'print-machine-property-pill-disabled': !operation.enabled}">
                        <span v-if="operation.enabled">включена</span>
                        <span v-else>отключена</span>
                    </div>
                </div>
                <div>
                    <span class="print-machine-property-name">Алгоритм:</span><span class="print-machine-property-value">{{algorithms.find(x=>x.id === operation.algorithm).name}}</span>
                </div>
                 <div>
                    <span class="print-machine-property-name">Коэффициент:</span><span class="print-machine-property-value">{{ operation.multiplier }}</span>
                </div>
                <div>
                    <OperationsTree :operations="operation" :isInEdit="isInEdit"/>
                </div>
             </div>
         </div>
    </div>
     <div class="col" v-else>
        <div class="row">
            <div class="col">
                <div class="d-flex print-machine-card-actions align-items-center justify-content-between">
                    <input type="text" placeholder="Название операции" class="form-control form-control-lg" v-model="operationForEdit.name">
                    <div class="d-flex">
                        <button type="button" class="btn btn-secondary ml-2" @click="cancelEdit">{{ $t('home.cancel') }}</button>
                        <button type="button" class="btn btn-primary ml-2" @click="saveAfterEdit">{{ $t('home.save') }}</button>
                    </div>
                </div>
            </div>
        </div>
         <div class="row mt-4">
             <div class="col print-machine-properties">
                <div>
                    <span class="print-machine-property-name">Статус:</span>
                    <div class="print-machine-property-pill" v-if="operationForEdit.enabled">
                        <span>включена</span>
                    </div>
                    <span class="cursor-pointer" v-else @click="operationForEdit.enabled = true">включена</span>
                     <div class="print-machine-property-pill print-machine-property-pill-disabled"  v-if="!operationForEdit.enabled">
                        <span>отключена</span>
                    </div>
                    <span class="cursor-pointer" v-else @click="operationForEdit.enabled = false">отключена</span>
                </div>
               <div class="form-inline mt-1">
                  <span class="print-machine-property-name">Алгоритм:</span>
                    <select class="form-control custom-select" v-model="operationForEdit.algorithm" id="algorithmId" :disabled="!isCanChangeAlgorithm">
                    <option v-for="algorithm in algorithms" :key="algorithm.id" :value="algorithm.id" :selected="algorithm.id === operationForEdit.algorithm">{{ algorithm.name }}</option>
                  </select>
                </div>
                <div class="form-inline mt-1">
                  <span class="print-machine-property-name">Коэффициент:</span>
                  <input type="text" class="form-control" id="multiplier" v-model="operationForEdit.multiplier" @blur="()=> operationForEdit.multiplier = operationForEdit.multiplier.replace(',', '.')">
                </div>
                <div v-if="operationForEdit.id">
                    <OperationsTree :operations="operationForEdit" :isInEdit="isInEdit" :printMachineId="printMachineId"/>
                </div>
             </div>
         </div>
        </div>
  </div>
</template>

<script>
import api from '../../../api'
import OperationsTree from '../../../components/OperationsTree.vue'

const defaultPrintMachine = () => {
  return {
    id: null,
    name: '',
    enabled: true,
    children: null,
    parent: null,
    algorithm: 1
  }
}

export default {
  name: 'OperationCard',
  components: {
    OperationsTree
  },
  props: {
    printMachineId: {
      default: null
    },
    operationId: {
      default: null
    }
  },
  data: () => {
    return {
      operation: null,
      isInEdit: false,
      operationForEdit: defaultPrintMachine(),
      algorithms: null
    }
  },
  methods: {
    loadPrintMachineOperation (opId) {
      api.get.printMachineOperations(this.pmId).then(resp => {
        this.operation = resp.data.data.operations.find(x => x.id === opId)
        this.operation.algorithm = this.operation.algorithm
          ? this.operation.algorithm.id
          : 1
      })
    },
    loadAlgorithms () {
      api.get.loadAlgorithms().then(resp => {
        this.algorithms = resp.data.data.algorithms
      })
    },
    closeCard () {
      this.$router.push({
        path: `/settings/print-machine-operations/${this.pmId}`
      })
    },
    editOperation () {
      if (this.opId) {
        this.operationForEdit = Object.assign({}, this.operation)
      } else {
        this.operationForEdit = defaultPrintMachine()
      }
      this.isInEdit = true
    },
    cancelEdit () {
      if (!this.opId) {
        this.closeCard()
      }
      this.isInEdit = false
    },
    deleteOperation () {
      this.$modal.show('dialog', {
        title: 'Внимание!',
        text: 'Вы уверены что хотите удалить?',
        buttons: [
          {
            title: 'Нет'
          },
          {
            title: 'Да',
            default: true,
            handler: () => {
              api.get
                .deletePrintMachineOperation(this.pmId, this.opId)
                .then(() => {
                  this.$eventBus.$emit('updatePrintMachineOperations')
                  this.$modal.hide('dialog')
                  this.closeCard()
                })
            }
          }
        ]
      })
    },
    saveAfterEdit () {
      if (this.opId) {
        if (this.operationForEdit.algorithm !== this.operation.algorithm) {
          this.operationForEdit.children = null
        }
        api.post
          .updatePrintMachineOperation(this.pmId, this.operationForEdit)
          .then(resp => {
            this.loadPrintMachineOperation(resp.data.data.operation.id)
            this.$eventBus.$emit('updatePrintMachineOperations')
            this.cancelEdit()
          })
          .catch(() => {
            this.cancelEdit()
          })
      } else {
        api.post
          .createPrintMachineOperation(this.pmId, this.operationForEdit)
          .then(resp => {
            this.$eventBus.$emit('updatePrintMachineOperations')
            this.$router.push({
              path: `/settings/print-machine-operations/${
                this.pmId
              }/operation-card/${resp.data.data.operation.id}`
            })
          })
          .catch(() => {
            this.cancelEdit()
          })
      }
    },
    refreshOperation () {
      api.get.printMachineOperations(this.pmId).then(resp => {
        const newOperation = resp.data.data.operations.find(
          x => x.id === this.opId
        )
        newOperation.algorithm = newOperation.algorithm.id
        this.operation = newOperation
        if (this.isInEdit) {
          this.operationForEdit = newOperation
        }
      })
    }
  },
  watch: {
    operationId: function (val) {
      if (+val) {
        this.isInEdit = false
        this.loadPrintMachineOperation(+val)
      } else {
        this.editOperation()
      }
    }
  },
  computed: {
    pmId () {
      return +this.printMachineId
    },
    opId () {
      return +this.operationId
    },
    isCanChangeAlgorithm () {
      return !this.operationForEdit.preset && (!this.operationForEdit.children || !this.operationForEdit.children.some(x => !!x.preset))
    }
  },
  created () {
    if (this.opId) {
      this.isInEdit = false
      this.loadPrintMachineOperation(this.opId)
    } else {
      this.editOperation()
    }
    this.loadAlgorithms()
    this.$eventBus
      .$off('addNewOperationEvent')
      .$on('addNewOperationEvent', operation => {
        api.post
          .createPrintMachineOperation(this.pmId, operation)
          .then(resp => {
            this.refreshOperation()
          })
          .catch(() => {
            this.$notify({
              message: 'Произошла ошибка',
              type: 'danger'
            })
          })
      })
    this.$eventBus
      .$off('deleteOperation')
      .$on('deleteOperation', operationId => {
        api.get
          .deletePrintMachineOperation(this.pmId, operationId)
          .then(resp => {
            this.refreshOperation()
          })
          .catch(() => {
            this.$notify({
              message: 'Произошла ошибка',
              type: 'danger'
            })
          })
      })
    this.$eventBus
      .$off('saveNewOperationNameEvent')
      .$on('saveNewOperationNameEvent', payload => {
        api.post
          .updatePrintMachineOperation(this.pmId, payload)
          .then(resp => {
            this.refreshOperation()
          })
      })
  }
}
</script>

<style>
</style>
